import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ isPrivate, isAuthorized }: any) => {
  return !isPrivate || isAuthorized ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
